import {Component, inject} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'admin-onboarding-payment-success',
  templateUrl: './admin-onboarding-payment-success.page.html',
  styleUrls: ['./admin-onboarding-payment-success.page.scss']
})
export class AdminOnboardingPaymentSuccessPage {

  readonly #router = inject(Router);

  readonly #activatedRoute = inject(ActivatedRoute);

  readonly #communityId: string = this.#activatedRoute.snapshot.params['communityId'];

  goHome() {
    this.#router.navigate(["/app"]);
  }

  goToMember() {
    this.#router.navigate(["/app/onboarding", this.#communityId, "member"]);
  }

}
